import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { Input } from 'antd';


const JsonProps = (props) => {
    const { TextArea } = Input;

    const [getJsonValue, setJsonValue] = useState("");

    useEffect(() => {
        let jsonData = props.propData !== null && 
        props.propData !== undefined && 
        props.propData.widgetData !== null && 
        props.propData.widgetData.length > 0 &&
        props.propData.widgetData[0];
        if(jsonData.hasOwnProperty("bind")){
            setJsonValue(jsonData.bind.data)
        }else{
            defaultForms();
        }
      }, [props]);

    const defaultForms = () => {
        setJsonValue("");
    }


    const onChangeJsonData = (event) => {
        let jsonData = {
            type : "JSON",
            data : event.target.value
        }
        setJsonValue(event.target.value)
        props._getPropsForIndex(props.widgetIndex, jsonData)
    };


    return <div >
        <Row>
            <Col className='pl-1'>
                <TextArea rows={4} placeholder="Type Json File" onChange={onChangeJsonData} value = {getJsonValue}/>
                {props.errorFlag && <small className='df-text-danger'>Please Enter Valid Json</small> }

            </Col>
        </Row>
    </div>
}
export default JsonProps;